module.exports = __webpack_public_path__ + "assets/img/icon5.de1cb620.png";